const routes = [{
  path: '/train/projectApproval',
  component: () => import('@/views/train/projectApproval'),
  name: 'train/projectApproval',
  meta: {
    title: '培训立项'
  }
}, {
  path: '/train/plan',
  component: () => import('@/views/train/plan'),
  name: 'train/plan',
  meta: {
    title: '培训计划'
  }
}, {
  path: '/train/trainingClass',
  component: () => import('@/views/train/trainingClass'),
  name: 'train/trainingClass',
  meta: {
    title: '培训班管理'
  }
}, {
  path: '/train/trainingResults',
  component: () => import('@/views/train/trainingResults'),
  name: 'train/trainingResults',
  meta: {
    title: '培训结果'
  }
}, {
  path: '/train/trainingStatistics',
  component: () => import('@/views/train/trainingStatistics'),
  name: 'train/trainingStatistics',
  meta: {
    title: '培训统计'
  }
}, {
  path: '/train/trainingLecturer',
  component: () => import('@/views/train/trainingLecturer'),
  name: 'train/trainingLecturer',
  meta: {
    title: '讲师管理'
  }
}, {
  path: '/train/trainingCourse',
  component: () => import('@/views/train/trainingCourse'),
  name: 'train/trainingCourse',
  meta: {
    title: '课程管理'
  }
}, {
  path: '/train/learningTime',
  component: () => import('@/views/train/learningTime'),
  name: 'train/learningTime',
  meta: {
    title: '培训学时记录'
  }
}, {
  path: '/train/batchTrainList',
  component: () => import('@/views/train/batchTrainList'),
  name: 'train/batchTrainList',
  meta: {
    title: '批量导出学时记录任务列表'
  }
}, {
  path: '/train/batchTrainResult',
  component: () => import('@/views/train/batchTrainResult'),
  name: 'train/batchTrainResult',
  meta: {
    title: '批量导出培训结果任务列表'
  }
}, {
  path: '/train/learningTimeParticulars',
  component: () => import('@/views/train/components/learningTimeParticulars'),
  name: 'train/learningTimeParticulars',
  meta: {
    title: '详情'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/human/train.js